// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__oWbE_","contact":"FAQ_contact__c4Oy3","textContent":"FAQ_textContent__JVMqx","faqContent":"FAQ_faqContent__SUXuq"};